// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: 'AIzaSyDqFbe3Mf_xzasRyNzLKEGm_rj3bqxB24M',
    authDomain: 'dynamicg-72e56.firebaseapp.com',
    projectId: 'dynamicg-72e56',
    storageBucket: 'dynamicg-72e56.appspot.com',
    messagingSenderId: '1063550043113',
    appId: '1:1063550043113:web:5b65f62e4681b025c80178',
    measurementId: 'G-EJSTDQ1Z4R',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
